import React, { useId } from 'react';
import { Box, Dialog, IconButton, Stack, Typography } from '@mui/material';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Close from '@mui/icons-material/Close';

const navStyle = { position: 'absolute', top: '50%', transform: 'translateY(-50%)', color: '#fff', bgcolor: 'rgba(255,255,255,.12)', '&:hover': { bgcolor: 'rgba(255,255,255,.24)' } };

// Shared full-size viewer: images load directly via <img>, so CORS never blocks them.
export default function ImageLightbox({ open, onClose, images, index, onStep, onError, itemName = 'photograph' }) {
  const titleId = useId();
  const image = images[index];
  if (!image) return null;
  const many = images.length > 1;
  return (
    <Dialog open={open} onClose={onClose} fullScreen aria-labelledby={titleId}
      onKeyDown={event => { if (!many) return; if (event.key === 'ArrowLeft') onStep(-1); if (event.key === 'ArrowRight') onStep(1); }}
      slotProps={{ paper: { sx: { bgcolor: 'rgba(8, 15, 26, .94)', color: '#fff', backgroundImage: 'none' } } }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ px: 2, py: 1, flexWrap: 'wrap' }}>
        <Typography id={titleId} variant="subtitle1" fontWeight={600} sx={{ flex: 1, minWidth: 0 }}>
          {image.label} {many && <Typography component="span" variant="body2" sx={{ opacity: .7 }}>({index + 1} of {images.length})</Typography>}
        </Typography>
        <IconButton onClick={onClose} aria-label="Close" sx={{ color: '#fff' }}><Close /></IconButton>
      </Stack>
      <Box sx={{ position: 'relative', flex: 1, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', px: { xs: 1, sm: 8 }, pb: 2 }}>
        <Box component="img" key={image.url} src={image.url} alt={`${image.label} full-size`} onError={() => onError?.(image.url)}
          sx={{ maxWidth: '100%', maxHeight: 'calc(100vh - 88px)', objectFit: 'contain', display: 'block' }} />
        {many && <>
          <IconButton onClick={() => onStep(-1)} aria-label={`Previous ${itemName}`} sx={{ ...navStyle, left: { xs: 4, sm: 16 } }}>
            <ChevronLeft fontSize="large" />
          </IconButton>
          <IconButton onClick={() => onStep(1)} aria-label={`Next ${itemName}`} sx={{ ...navStyle, right: { xs: 4, sm: 16 } }}>
            <ChevronRight fontSize="large" />
          </IconButton>
        </>}
      </Box>
    </Dialog>
  );
}
